// Generated by Melange

import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service from "../../../../proto/platformapis/gen/buhta_idp_v1alpha1_admin_identity_service.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";

const Identity = {};

function toCreateRequest(form) {
  return Curry._2(Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.CreateIdentityRequest.make, form, undefined);
}

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.UpdateIdentityRequest.make, id, form, undefined);
}

function view(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._3(Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.GetIdentityRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                const identity = response.identity;
                if (identity !== undefined) {
                  return identity;
                }
                throw new Caml_js_exceptions.MelangeError(Stdlib.Not_found, {
                          MEL_EXN_ID: Stdlib.Not_found
                        });
              }), Buhta_core__Grpc.makeRpc(request, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.getIdentity, undefined, tenant, undefined, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.GetIdentity.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.ListIdentitiesRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.identities;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.listIdentities, undefined, tenant, undefined, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.ListIdentities.name, undefined, undefined));
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                const identity = response.identity;
                if (identity !== undefined) {
                  return identity;
                }
                throw new Caml_js_exceptions.MelangeError(Stdlib.Not_found, {
                          MEL_EXN_ID: Stdlib.Not_found
                        });
              }), Buhta_core__Grpc.makeRpc(toCreateRequest(form), Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.createIdentity, undefined, tenant, undefined, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.CreateIdentity.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                const identity = response.identity;
                if (identity !== undefined) {
                  return identity;
                }
                throw new Caml_js_exceptions.MelangeError(Stdlib.Not_found, {
                          MEL_EXN_ID: Stdlib.Not_found
                        });
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest(id, form), Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.updateIdentity, undefined, tenant, undefined, Buhta_platformapis__Buhta_idp_v1alpha1_admin_identity_service.Buhta.Idp.V1alpha1.AdminIdentityService.UpdateIdentity.name, undefined, undefined));
}

const IdentityForm = {};

const AdminIdentityService = {
  grid: grid,
  view: view,
  create: create,
  update: update
};

export {
  Identity ,
  IdentityForm ,
  AdminIdentityService ,
}
/* Buhta_core__Grpc Not a pure module */
